module.exports = __webpack_public_path__ + "img/control.4d85a025.svg";